<template>
  <div class="landing-product-item-wrap">
    <div class="landing-product-item">
      
      <p class="brand" v-if="product.brand">{{ product.brand.name }}</p>
      <img v-if="product.image" :src="product.image" class="store-landing-thumb" />
      <img v-else src="@/assets/img/leaf.png" :alt="product.name" class="store-landing-thumb" />
      <h3>{{ product.name }}</h3>
      <div class="product-type">
        <div class="store-item-plant-type is-inline-block" v-if="product.product_family == 'cannabis'">
          <div :class="'plant-type-capsule relative is-capitalized is-size-7 ' + ( product.cannabis_attributes && product.cannabis_attributes.plant_type ? product.cannabis_attributes.plant_type : 'na')">
            <span>{{ product.cannabis_attributes && product.cannabis_attributes.plant_type ? product.cannabis_attributes.plant_type : '--N/A-'}}</span>
          </div>
        </div>
      </div>

      <div class="thc-cbd">
        <template v-if="product.product_family == 'cannabis'">
          <p><span>THC</span> {{ thc }}</p>
          <p><span>CBD</span> {{ cbd }}</p>
        </template>
      </div>
      <div class="sale-alert">
         <span v-if="productOnSale" class="st-item-sale relative-tag has-text-weight-semibold">{{ productOnSalePercentage }}</span>
      </div>
      <button @click.prevent="addToCart()" class="add-to-cart is-fixed-add-to-cart">Add to stash</button>
    </div>
  </div>
</template>

<script>
import Env from "@/env";
import Helpers from '@/Components/Helpers/Helpers';
export default {
  name: 'LocationLandingItem',
  data() {
    return {
      productOnSale: false,
      productOnSalePercentage: false,
    }
  },
  props:['product'],

  computed: {
    plant_type() {
      return Env.product_type;
    },
    thc() {
      let thc = Helpers.getTHCValue(this.product);
      if(thc == ''){
        return '--n/a--';
      }
      return thc;
    },
    cbd() {
      let cbd = Helpers.getCBDValue(this.product);
      if(cbd == ''){
        return '--n/a--';
      }
      return cbd;
    },
  },

  mounted() {
    this.productPrice();
  },

  methods: {
    /**
     * Product price
     */
     productPrice() {
      if(this.product.variants[0] && this.product.variants[0].price){
        if(this.product.variants[0].sale_price && this.product.variants[0].sale_price < this.product.variants[0].price){
          this.productOnSale = true;
   
          let salePercentData = ((this.product.variants[0].price-this.product.variants[0].sale_price) / this.product.variants[0].price)*100;
          this.productOnSalePercentage = ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% off';
        } else {
          this.productOnSale = false;
        }
      } else {
        this.productOnSale = false;
      }
  
    },
    /**
     * Add to cart
     */
    addToCart(data) {
      bus.$emit('location-landing-addto-cart', {
        modal: true,
        product: { id: this.product.id },
      });
    },
    /**
     * First letter uppercase
     */
    firstLetterUppercase(s) {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
};
</script>